import { createSlice } from '@reduxjs/toolkit'
import {
  createQuestion,
  getCategories,
  getEvents,
  getMarkets,
  getRecentTrades,
  getQuestionDetails,
  getTopHolders,
  getTradeSummary,
  getQuestionSummary,
  getTradingFeeReport
} from 'redux-thunk/thunk/PredictionMarket/predictionMarket'
import { EMPTY_QUESTION_SUMMARY } from 'utils/constants/index'

const initialState = {
  markets: null,
  categories: [],
  categoryTree: [],
  questionDetails: null,
  settledOptions: null,
  recentTrades: null,
  topYesHolders: null,
  topNoHolders: null,
  tradeSummary: null,
  questionSummary: EMPTY_QUESTION_SUMMARY,
  externalEvents: null,
  tradingFeeReport: null
}

const predictionMarketSlice = createSlice({
  name: 'predictionMarketSlice',
  initialState,
  reducers: {
    clearQuestionSummary: (state) => ({
      ...state,
      questionSummary: EMPTY_QUESTION_SUMMARY
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMarkets.fulfilled, (state, action) => ({
        ...state,
        markets: action.payload
      }))
      .addCase(getCategories.fulfilled, (state, action) => ({
        ...state,
        categories: action.payload?.categories || action.payload || [],
        categoryTree: action.payload?.tree || []
      }))
      .addCase(getQuestionDetails.fulfilled, (state, action) => {
        if (action.meta.arg?.state === 'settled') {
          state.settledOptions = action.payload
        } else {
          state.questionDetails = action.payload
        }
      })

      .addCase(getRecentTrades.fulfilled, (state, action) => ({
        ...state,
        recentTrades: action.payload
      }))
      .addCase(getTopHolders.fulfilled, (state, action) => ({
        ...state,
        ...(action.meta.arg?.outcome === 'yes'
          ? { topYesHolders: action.payload }
          : { topNoHolders: action.payload })
      }))
      .addCase(getTradeSummary.fulfilled, (state, action) => ({
        ...state,
        tradeSummary: action.payload
      }))
      .addCase(getQuestionSummary.fulfilled, (state, action) => ({
        ...state,
        questionSummary: action.payload || EMPTY_QUESTION_SUMMARY
      }))
      .addCase(getQuestionSummary.rejected, (state) => ({
        ...state,
        questionSummary: EMPTY_QUESTION_SUMMARY
      }))
      .addCase(getEvents.fulfilled, (state, action) => ({
        ...state,
        externalEvents: action.payload
      }))
      .addCase(getTradingFeeReport.fulfilled, (state, action) => ({
        ...state,
        tradingFeeReport: action.payload
      }))
      .addCase(createQuestion.fulfilled, (state) => ({
        ...state
      }))
  }
})

export const { clearQuestionSummary } = predictionMarketSlice.actions

export default predictionMarketSlice.reducer
